import { Link } from 'react-router-dom';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import IconContainer from '../../common/IconContainer';
import './style.css'
import { useIsMobile } from '../../../hooks/useIsMobile';
import React, { useState } from 'react';
import IMAGES_PATH from '../../../Images'
import { Touchable } from '../../common/Touchable';
import { useNavigation } from '../../../hooks/useNavigate';

const NavBar = () => {

  const {
    goToHome,
    goToSupport,
    goToContactUs,
  } = useNavigation()

  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const isMobile = useIsMobile()

  return (
    <div className={`nav-bar box-with-shadow`}>
      <div className={`icon-wrapper`}>
        <Touchable onClick={goToHome}>
          <div className={`icon-wrapper`}>
            <IconContainer
              image_path={IMAGES_PATH.LOGO}
            />
            <h5>{t(TEXT_KEYS.SO_APP)}</h5>
          </div>
        </Touchable>
      </div>
      <div className='nav-link-container'>
        {isMobile ?
          <Touchable onClick={() => setIsSubmenuOpen(true)}>
            <img src={IMAGES_PATH.BURGER_MENU} alt="Burger Menu Icon" />
          </Touchable>
          :
          <>
            <Link to="/mission" className="nav-link">{t(TEXT_KEYS.OUR_MISSION)}</Link>
            <Link to="/eu_regulation" className="nav-link">{t(TEXT_KEYS.EU_REGULATIONS)}</Link>
            <Link to="/contact_us" className="nav-link">{t(TEXT_KEYS.CONTACT)}</Link>
            <Link to="/about_us" className="nav-link">{t(TEXT_KEYS.ABOUT_US)}</Link>
          </>
        }
      </div>
      <Button
        label={t(TEXT_KEYS.SUPPORT_US)}
        onClick={goToSupport}
      />
      {isMobile && isSubmenuOpen && (
        <div className="submenu-backdrop" onClick={() => setIsSubmenuOpen(false)}>
          <div
            className="submenu-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="submenu-content">
              <button className="close-btn" onClick={() => setIsSubmenuOpen(false)}>×</button>
              <Link to="/mission" className="nav-link" onClick={() => setIsSubmenuOpen(false)}>{t(TEXT_KEYS.OUR_MISSION)}</Link>
              <Link to="/eu_regulation" className="nav-link" onClick={() => setIsSubmenuOpen(false)}>{t(TEXT_KEYS.EU_REGULATIONS)}</Link>
              <Link to="/contact_us" className="nav-link" onClick={() => { goToContactUs(); setIsSubmenuOpen(false); }}>{t(TEXT_KEYS.CONTACT)}</Link>
              <Link to="/about_us" className="nav-link" onClick={() => setIsSubmenuOpen(false)}>{t(TEXT_KEYS.ABOUT_US)}</Link>
            </div>
          </div>
        </div>
      )}
    </div>

  );
};

export default NavBar;